module.exports = __webpack_public_path__ + "static/bg03-a5122362ddd44cddac79a884b8e44293.jpg";